import React, { Component } from 'react';

// Style
import './Version.css';
// WS
import VersionService from '../../services/VersionService';


class Version extends Component {

    /**********************************************************
     * ******************** LifeCycle *************************
     **********************************************************/
    constructor(props) {
        super(props);
        this.state = {};
        this._promises = [];
    }

    componentWillMount() {
        this.getVersion();
    }


    /**
     * Annulation de toutes les promesses encore en cours lorsque
     * l'on quitte le composant
     */
    componentWillUnMount() {
        this._promises.forEach(promise => promise.cancel());
    }

    render() {
        return(
            <div className='versionPage'>
                <p>ReactApp : <b>{process.env.REACT_APP_VERSION}</b></p>
                <p>Api : <b>{this.state.apiVersion}</b></p>
            </div>
        );
    }

    /**********************************************************
     * ******************* Web Services ***********************
     **********************************************************/

    getVersion() {
        VersionService.getApiVersion().then((response) => {
            this.setState({apiVersion: response.version});
        });
    }


}

export default (Version);


// WEBPACK FOOTER //
// ./src/ui/version/Version.js